import React from 'react';
import { Notification as NotificationT } from 'api/notifications';
import { EventType } from 'api/notifications/meta';
import { ApprovalApprovedComment } from './approval-approved-comment';
import { ApprovalRequestChangeComment } from './approval-request-change-comment';
import { ApprovalRequestedComment } from './approval-requested-comment';
import { Content } from './content';
import { MessageReactionAddedView } from './message-reaction-added';
import { MessageReplyAddedView } from './message-reply-added';
import { ProjectCsatAddedInfo } from './project-csat-added';
import { TimeoffNote } from './timeoff';
import { TimesheetComment } from './timesheet-events/timesheet-comment';

export const renderInfo = ({ meta }: NotificationT) => {
  switch (meta.eventType) {
    case EventType.MessageCreated:
    case EventType.UserMentionedInMessage:
      return <Content data={meta.message?.content ?? ''} />;
    case EventType.UserMentionedInTask:
    case EventType.UserMentionedInDocument:
      return <Content data={meta.preview} />;
    case EventType.MessageReactionAdded:
      return <MessageReactionAddedView meta={meta} />;
    case EventType.MessageReplyAdded:
      return <MessageReplyAddedView meta={meta} />;
    case EventType.ProjectCsatAdded:
      return <ProjectCsatAddedInfo meta={meta} />;
    case EventType.ApprovalRequested:
      return <ApprovalRequestedComment meta={meta} />;
    case EventType.ApprovalRequestChangesRequested:
      return <ApprovalRequestChangeComment meta={meta} />;
    case EventType.ApprovalRequestApproved:
      return <ApprovalApprovedComment meta={meta} />;
    case EventType.TimeOffCreated:
      return <TimeoffNote meta={meta} />;
    case EventType.TimesheetApproved:
      return <TimesheetComment meta={meta} />;
    default:
      return null;
  }
};
